import { createClient } from "@/apollo/clientUtils";
import { createHttpLink } from "apollo-link-http";

const dataSourceLink = createHttpLink({
  uri: "/absence-system/private/data"
});

export const absence = createClient(dataSourceLink);
